/**
 * Do not edit directly
 * Generated on Fri, 25 Oct 2024 05:27:50 GMT
 */

export const FontWeightDefault = 400;
export const FontWeightBold = 500;
export const ColorBaseTransparentDefault = "rgba(0, 0, 0, 0)";
export const ColorBaseNeutral0 = "#ffffff";
export const ColorBaseNeutral50 = "#fcfcfc";
export const ColorBaseNeutral100 = "#fafafa";
export const ColorBaseNeutral200 = "#f5f5f5";
export const ColorBaseNeutral300 = "#f0f0f0";
export const ColorBaseNeutral400 = "#d9d9d9";
export const ColorBaseNeutral500 = "#bfbfbf";
export const ColorBaseNeutral600 = "#888888";
export const ColorBaseNeutral700 = "#565656";
export const ColorBaseNeutral800 = "#252525";
export const ColorBaseNeutral900 = "#000000";
export const ColorBaseBlue50 = "#f4f6ff";
export const ColorBaseBlue100 = "#d7dff7";
export const ColorBaseBlue200 = "#a2b2dd";
export const ColorBaseBlue300 = "#7589c6";
export const ColorBaseBlue400 = "#5469ae";
export const ColorBaseBlue500 = "#3451a1";
export const ColorBaseBlue600 = "#2e4998";
export const ColorBaseBlue700 = "#23408c";
export const ColorBaseBlue800 = "#1b3580";
export const ColorBaseBlue900 = "#0f246a";
export const ColorBaseBlueGray50 = "#F4F6FA";
export const ColorBaseBlueGray100 = "#E4E9F0";
export const ColorBaseBlueGray200 = "#D4DBE6";
export const ColorBaseBlueGray300 = "#C1CBDA";
export const ColorBaseBlueGray400 = "#B1BCCE";
export const ColorBaseBlueGray500 = "#A0ADC3";
export const ColorBaseBlueGray600 = "#909DAF";
export const ColorBaseBlueGray700 = "#7C8796";
export const ColorBaseBlueGray800 = "#6B7380";
export const ColorBaseBlueGray900 = "#565C66";
export const ColorBaseGreen50 = "#e8f5f7";
export const ColorBaseGreen100 = "#b4dadc";
export const ColorBaseGreen200 = "#82c3c5";
export const ColorBaseGreen300 = "#53abac";
export const ColorBaseGreen400 = "#369a9a";
export const ColorBaseGreen500 = "#278987";
export const ColorBaseGreen600 = "#227c7a";
export const ColorBaseGreen700 = "#206d6a";
export const ColorBaseGreen800 = "#225d5a";
export const ColorBaseGreen900 = "#18423e";
export const ColorBaseRed50 = "#fdf4f4";
export const ColorBaseRed100 = "#fbcec2";
export const ColorBaseRed200 = "#eda796";
export const ColorBaseRed300 = "#e8866d";
export const ColorBaseRed400 = "#e76b51";
export const ColorBaseRed500 = "#e35436";
export const ColorBaseRed600 = "#d84f33";
export const ColorBaseRed700 = "#cc472e";
export const ColorBaseRed800 = "#bb432b";
export const ColorBaseRed900 = "#a43822";
export const ColorBaseYellow50 = "#fff8e6";
export const ColorBaseYellow100 = "#fcedc1";
export const ColorBaseYellow200 = "#fae299";
export const ColorBaseYellow300 = "#f6d673";
export const ColorBaseYellow400 = "#f1ce57";
export const ColorBaseYellow500 = "#efc63d";
export const ColorBaseYellow600 = "#dfb738";
export const ColorBaseYellow700 = "#c8a134";
export const ColorBaseYellow800 = "#b28b2e";
export const ColorBaseYellow900 = "#8d6827";
export const ColorBasePurple50 = "#f3effc";
export const ColorBasePurple100 = "#d1c6e9";
export const ColorBasePurple200 = "#b3a2db";
export const ColorBasePurple300 = "#947ccc";
export const ColorBasePurple400 = "#7d5fc1";
export const ColorBasePurple500 = "#6745b6";
export const ColorBasePurple600 = "#5e3fb0";
export const ColorBasePurple700 = "#5238a6";
export const ColorBasePurple800 = "#47329e";
export const ColorBasePurple900 = "#35278e";
export const ColorBaseOrange50 = "#fff3e0";
export const ColorBaseOrange100 = "#ffdfb1";
export const ColorBaseOrange200 = "#fecc80";
export const ColorBaseOrange300 = "#ffb74d";
export const ColorBaseOrange400 = "#ffa726";
export const ColorBaseOrange500 = "#ff9800";
export const ColorBaseOrange600 = "#fb8d00";
export const ColorBaseOrange700 = "#f57c02";
export const ColorBaseOrange800 = "#f06c00";
export const ColorBaseOrange900 = "#de5b01";
export const ColorBasePink50 = "#fbe5ea";
export const ColorBasePink100 = "#f5becc";
export const ColorBasePink200 = "#ee95aa";
export const ColorBasePink300 = "#e86e8a";
export const ColorBasePink400 = "#e25472";
export const ColorBasePink500 = "#db435d";
export const ColorBasePink600 = "#cb3e5a";
export const ColorBasePink700 = "#b63855";
export const ColorBasePink800 = "#a13452";
export const ColorBasePink900 = "#7b2b48";
export const ColorBaseLightBlue50 = "#e5f6ff";
export const ColorBaseLightBlue100 = "#b9ecfe";
export const ColorBaseLightBlue200 = "#8ee1fc";
export const ColorBaseLightBlue300 = "#68d4f7";
export const ColorBaseLightBlue400 = "#55c9f1";
export const ColorBaseLightBlue500 = "#50c1ea";
export const ColorBaseLightBlue600 = "#48B1D6";
export const ColorBaseLightBlue700 = "#3c9cba";
export const ColorBaseLightBlue800 = "#3587a1";
export const ColorBaseLightBlue900 = "#246574";
export const ColorBaseLightPurple50 = "#f3e5f2";
export const ColorBaseLightPurple100 = "#e1bee0";
export const ColorBaseLightPurple200 = "#cd96cc";
export const ColorBaseLightPurple300 = "#ba6db8";
export const ColorBaseLightPurple400 = "#a950a8";
export const ColorBaseLightPurple500 = "#9a379a";
export const ColorBaseLightPurple600 = "#8d3294";
export const ColorBaseLightPurple700 = "#7d2b8a";
export const ColorBaseLightPurple800 = "#6d2882";
export const ColorBaseLightPurple900 = "#531e71";
export const ColorBaseLightGreen50 = "#e6f5ed";
export const ColorBaseLightGreen100 = "#c4e4d2";
export const ColorBaseLightGreen200 = "#9ed4b7";
export const ColorBaseLightGreen300 = "#77c19b";
export const ColorBaseLightGreen400 = "#5ab587";
export const ColorBaseLightGreen500 = "#3ca973";
export const ColorBaseLightGreen600 = "#379a68";
export const ColorBaseLightGreen700 = "#2f875b";
export const ColorBaseLightGreen800 = "#2c7750";
export const ColorBaseLightGreen900 = "#23573b";
export const ColorBaseBlackDefault = "#000000";
export const ColorBaseWhiteDefault = "#ffffff";
export const ColorBasePrimary50 = "var(--color-base-primary-50)";
export const ColorBasePrimary100 = "var(--color-base-primary-100)";
export const ColorBasePrimary200 = "var(--color-base-primary-200)";
export const ColorBasePrimaryLight = "var(--color-base-primary-light)";
export const ColorBasePrimaryDefault = "var(--color-base-primary-default)";
export const ColorBasePrimaryDark = "var(--color-base-primary-dark)";
export const ColorBaseStatusProcessing = "#3451a1";
export const ColorBaseStatusError = "#cc472e";
export const ColorBaseStatusSuccess = "#227c7a";
export const ColorBaseStatusWarning = "#efc63d";
export const ColorMessageBackgroundInfo = "#f4f6ff";
export const ColorMessageBackgroundSuccess = "#e8f5f7";
export const ColorMessageBackgroundError = "#fdf4f4";
export const ColorMessageBackgroundWarning = "#fff8e6";
export const ColorMessageTextDetail = "#565656";
export const ColorMessageTextInfo = "#3451a1";
export const ColorMessageTextSuccess = "#206d6a";
export const ColorMessageTextError = "#cc472e";
export const ColorMessageTextWarning = "#8d6827";
export const ColorTextPrimary = "var(--color-text-primary)";
export const ColorTextSecondary = "#565656";
export const ColorTextTertiary = "#888888";
export const ColorTextDisable = "#bfbfbf";
export const SizeTypographyFontSizeH1 = "1.5rem";
export const SizeTypographyFontSizeH2 = "1.25rem";
export const SizeTypographyFontSizeH3 = "1rem";
export const SizeTypographyFontSizeH4 = "0.875rem";
export const SizeTypographyFontSizeH5 = "0.75rem";
export const SizeTypographyFontSizeNormal = "0.875rem";
export const SizeTypographyFontSizeSmall = "0.875rem";
export const SizeTypographyFontSizeT1 = "0.875rem";
export const SizeTypographyFontSizeT2 = "0.875rem";
export const SizeTypographyFontSizeT3 = "0.75rem";
export const SizeTypographyLineHeightH1 = "2rem";
export const SizeTypographyLineHeightH2 = "1.75rem";
export const SizeTypographyLineHeightH3 = "1.5rem";
export const SizeTypographyLineHeightH4 = "1.375rem";
export const SizeTypographyLineHeightH5 = "1.125rem";
export const SizeTypographyLineHeightNormal = "1.375rem";
export const SizeTypographyLineHeightSmall = "1.125rem";
export const SizeTypographyLineHeightT1 = "1.5rem";
export const SizeTypographyLineHeightT2 = "1.375rem";
export const SizeTypographyLineHeightT3 = "1.125rem";
export const SizeSquareLengthDefault = "1rem";
export const SizeSquareLengthSmall = "0.5rem";
export const SizeSpacingPaddingXDefault = "1rem";
export const SizeSpacingPaddingXSmall = "0.75rem";
export const SizeSpacingPaddingYDefault = "0.25rem";
export const SizeSpacingPaddingYSmall = "0.25rem";
export const SizeShapeRadiusDefault = "2px";
export const SizeShapeRadiusLarge = "4px";
export const SizeToastFontSizeTitle = "0.875rem";
export const SizeToastFontSizeDetail = "0.75rem";
export const SizeToastLineHeightTitle = "1.375rem";
export const SizeToastLineHeightDetail = "1.125rem";
export const ShadowS1Shadow0OffsetX = "0";
export const ShadowS1Shadow0OffsetY = "0";
export const ShadowS1Shadow0Radius = "1px";
export const ShadowS1Shadow0Color = "rgba(0, 0, 0, 0.06)";
export const ShadowS1Shadow1OffsetX = "0";
export const ShadowS1Shadow1OffsetY = "1px";
export const ShadowS1Shadow1Radius = "4px";
export const ShadowS1Shadow1Color = "rgba(51, 51, 51, 0.04)";
export const ShadowS2Shadow0OffsetX = "0";
export const ShadowS2Shadow0OffsetY = "0";
export const ShadowS2Shadow0Radius = "1px";
export const ShadowS2Shadow0Color = "rgba(0, 0, 0, 0.12)";
export const ShadowS2Shadow1OffsetX = "0";
export const ShadowS2Shadow1OffsetY = "2px";
export const ShadowS2Shadow1Radius = "4px";
export const ShadowS2Shadow1Color = "rgba(0, 0, 0, 0.08)";
export const ShadowS3Shadow0OffsetX = "0";
export const ShadowS3Shadow0OffsetY = "4px";
export const ShadowS3Shadow0Radius = "8px";
export const ShadowS3Shadow0Color = "rgba(0, 0, 0, 0.08)";
export const ShadowS3Shadow1OffsetX = "0";
export const ShadowS3Shadow1OffsetY = "0";
export const ShadowS3Shadow1Radius = "1px";
export const ShadowS3Shadow1Color = "rgba(0, 0, 0, 0.12)";
export const ShadowS4Shadow0OffsetX = "0";
export const ShadowS4Shadow0OffsetY = "8px";
export const ShadowS4Shadow0Radius = "12px";
export const ShadowS4Shadow0Color = "rgba(0, 0, 0, 0.12)";
export const ShadowS4Shadow1OffsetX = "0";
export const ShadowS4Shadow1OffsetY = "0";
export const ShadowS4Shadow1Radius = "1px";
export const ShadowS4Shadow1Color = "rgba(0, 0, 0, 0.16)";
